import { createSyncRunner } from '../platform/sync-runner';
import { tdb, TODO_TABLE_MAP } from './db';

/**
 * The todo sync loop — the platform runner bound to this module's own Dexie
 * database, outbox and endpoint. Started alongside (and independently of) the
 * groceries and agenda loops when the app is signed in.
 */
export const todoSync = createSyncRunner({
  endpoint: '/api/v1/todos/sync',
  db: tdb,
  outbox: tdb.outbox,
  meta: tdb.meta,
  rejections: tdb.rejections,
  tables: TODO_TABLE_MAP,
  sinceKey: 'todos_since',
  lastOkKey: 'todos_last_ok',
});

export const startTodoSync = () => todoSync.startLoop();
